import { render, staticRenderFns } from "./BranchForm.vue?vue&type=template&id=9904614e&scoped=true"
import script from "./BranchForm.vue?vue&type=script&lang=js"
export * from "./BranchForm.vue?vue&type=script&lang=js"
import style0 from "./BranchForm.vue?vue&type=style&index=0&id=9904614e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9904614e",
  null
  
)

export default component.exports